import React from 'react';
import EducateCustomer from './EducateCustomer';
import VerifyCustomer from './VerifyCustomer';

interface EmailVerifyPropsType {
  sourceType: string; // VERIFY/EDUCATE
  isDesktop: boolean;
  ctaLabel: string | undefined;
}

const EmailVerify = (props: EmailVerifyPropsType) => {
  const { sourceType = 'VERIFY', isDesktop = true, ctaLabel = '' } = props;
  return (
    <>
      {sourceType === 'EDUCATE' && ctaLabel && <EducateCustomer ctaLabel={ctaLabel} />}
      {sourceType === 'VERIFY' && <VerifyCustomer ctaLabel={ctaLabel} isDesktop={isDesktop} />}
    </>
  );
};

export default EmailVerify;
